export default __webpack_public_path__ + "static/media/ETH.5e73b4fb.png";